// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2uXYC","buttons":"PendingPaymentAlert_buttons__2jmxk"};